<h2 mat-dialog-title class="dialog-title">
  <mat-icon [color]="canConfirm ? 'accent' : 'warn'">{{ iconName }}</mat-icon>
  <span>{{ titleKey | transloco }}</span>
</h2>

<mat-divider></mat-divider>

<mat-dialog-content class="dialog-content">
  <div class="info-row">
    <mat-icon color="primary">analytics</mat-icon>
    <div class="info-text">
      <span class="info-label">{{ 'confirmAnalysisDialog.analysisType' | transloco }}</span>
      <span class="info-value">{{ data.analysisTypeLabel }}</span>
    </div>
  </div>

  <div class="info-row">
    <mat-icon color="primary">stars</mat-icon>
    <div class="info-text">
      <span class="info-label">{{ 'confirmAnalysisDialog.cost' | transloco }}</span>
      <span class="info-value">{{ data.cost | number }}</span>
    </div>
  </div>

  <div class="info-row" [class.highlight-warn]="canConfirm" [class.highlight-error]="!canConfirm">
    <mat-icon [color]="canConfirm ? 'accent' : 'warn'">account_balance_wallet</mat-icon>
    <div class="info-text">
      <span class="info-label">{{ 'confirmAnalysisDialog.availableCredits' | transloco }}</span>
      <span class="info-value">{{ data.availableCredits | number }}</span>
    </div>
  </div>

  <p *ngIf="messageKey" class="message" [class.message-warn]="canConfirm" [class.message-error]="!canConfirm">
    {{ messageKey | transloco }}
  </p>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button type="button" (click)="doDecline()">
    {{ (canConfirm ? 'common.buttons.cancel' : 'common.buttons.close') | transloco }}
  </button>
  <button *ngIf="canConfirm" mat-raised-button color="primary" type="button" (click)="doConfirm()">
    {{ 'common.buttons.confirm' | transloco }}
  </button>
</mat-dialog-actions>
